import posthog from 'posthog-js'
import { PostHogProvider as PostHogJSProvider } from 'posthog-js/react'
import { type PropsWithChildren, useEffect } from 'react'

import {
  consumeChunkLoadRecovery,
  resetChunkLoadRetryAttempts,
} from '@/lib/chunkLoadRecovery'
import { postHogTrackingService } from '@/services/PostHogTrackingService'
import { referralAttributionService } from '@/services/ReferralAttributionService'

postHogTrackingService.init()
referralAttributionService.captureIfNeeded()

const ChunkLoadRecoveryReporter = () => {
  useEffect(() => {
    const recovery = consumeChunkLoadRecovery()

    resetChunkLoadRetryAttempts()

    if (recovery) {
      postHogTrackingService.trackEvent('chunk_load_recovered', { ...recovery })
    }
  }, [])

  return null
}

export const PostHogProvider = ({ children }: PropsWithChildren) => (
  <PostHogJSProvider client={posthog}>
    <ChunkLoadRecoveryReporter />
    {children}
  </PostHogJSProvider>
)
